export default {
  'journey-management': ['journey_management']
}
